import type { EmbeddedSchemaType } from '@vedalib/editor/lib/brand'
import type { EmbeddedElementValue } from '@vedalib/editor/lib/elements'

import ControlItem from 'components/Editor/cource/layout/controls/ControlItem'
import { useOpenModal } from 'components/uiKit/Modal'
import { t } from 'services/Translation'

import type { FCEditorActions } from '../../elements.types'
import CodeEditorModal from './components/CodeEditorModal'

const OPEN_EDITOR_ACTION = {
  icon: 'iconsOtherCode',
  value: 'openEditor',
  label: t('elements.embedded.form.openEditor'),
} as const

const EmbeddedEditorActions: FCEditorActions<EmbeddedElementValue, EmbeddedSchemaType> = ({
  onChange,
  element,
}) => {
  const modal = useOpenModal(CodeEditorModal, {})
  const handleChange = () => {
    modal.open({
      name: 'CodeEditorModal',
      value: element.value.html,
      onChange: (code) => onChange({ ...element.value, html: code }),
    })
  }
  if (element.value.type === 'html') {
    return <ControlItem handler={handleChange} option={OPEN_EDITOR_ACTION} />
  }

  return null
}

export default EmbeddedEditorActions
